module.exports = __webpack_public_path__ + "static/ToothBrushwPaste-e7dd52c26fe178f1db4468247ef556d6.jpg";